module.exports = __webpack_public_path__ + "media/images/plans/propose_restaurant/dinner-course-photo-3-3-91e6fb8391c2fa710fdf7f5183867cc9.jpg";